<template>
    <!-- 合伙人数据 -->
    <div class="container">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">姓名/手机号:</span>
                    <el-input
                        v-model="search_data.promoter_name_phone"
                        placeholder="请输入姓名/手机号 "
                        @keyup.enter.native="searchDistributionPromoterLists"
                        style="width: 200px"
                    ></el-input>
                </el-col>
                <el-col :span="12">
                    <span class="title">入驻时间:</span>
                    <el-date-picker
                        v-model="time_fixed"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd "
                        value-format="yyyy-MM-dd"
                        @change="timeChange"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchDistributionPromoterLists">搜索</el-button>

            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="id" label="id" min-width="50"> </el-table-column>

            <el-table-column prop="promoter_name" label="合伙人姓名" min-width="80"> </el-table-column>

            <el-table-column prop="promoter_phone" label="手机号" min-width="90"> </el-table-column>
            <el-table-column prop="create_time" label="入驻时间" min-width="100"> </el-table-column>
            <el-table-column prop="promoter_count" label="累计邀请下级" min-width="80"> </el-table-column>
            <el-table-column prop="user_count" label="累计邀请用户" min-width="80"> </el-table-column>
            <el-table-column prop="order_count" label="累计成交订单数量" min-width="80"> </el-table-column>
            <el-table-column prop="commission_amount" label="累计获得佣金" min-width="80"> </el-table-column>

            <el-table-column label="操作" width="260">
                <template slot-scope="scope">
                    <el-button type="primary" @click="invite(scope.row, 'xia')"> 邀请的下级 </el-button>
                    <el-button type="success" @click="invite(scope.row, 'user')"> 邀请的用户 </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 邀请的下级 -->
        <distributionNextPromoterLists
            :isShow="xia_show"
            :data="xia_children"
            @onSubmit="searchDistributionPromoterLists"
        ></distributionNextPromoterLists>

        <!-- 邀请的用户 -->
        <distributionUserLists
            :isShow="user_show"
            :data="user_children"
            @onSubmit="searchDistributionPromoterLists"
        ></distributionUserLists>
    </div>
</template>

<script>
var _this;
import bus from '@/components/common/bus.js';

import distributionNextPromoterLists from './distributionNextPromoterLists.vue';
import distributionUserLists from './distributionUserLists.vue';
export default {
    components: {
        distributionNextPromoterLists,
        distributionUserLists
    },

    data() {
        return {
            time_fixed: '',
            loading: false,
            excelData: [],

            excelHead: [],
            // 选择是否全部推送下拉
            value_all_audience: '',

            xia_show: false,
            user_show: false,

            // 子组件的传入数据
            xia_children: '',
            user_children: '',

            // 存放表格数据
            tableData: [],
            city_data: [],

            // 选项卡默认选中项
            activeName: 'all',

            // 下拉搜索管理状态
            value_status_array: [],

            // 下拉搜索端口
            val_port_array: '',

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                promoter_name_phone: '',
                create_time: ''
            },
            submit_data: {
                bug_code: '',
                status: '',
                remarks: '',
                type: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchDistributionPromoterLists();
    },
    mounted() {
        // 通过 Event Bus
        bus.$on('getCity', (msg) => {
            _this.searchDistributionPromoterLists();
        });
    },
    beforeDestroy() {
        bus.$off('getCity');
    },

    methods: {
        // 邀请的下级/邀请的用户方法

        invite(e, val) {
            if (val == 'xia') {
                // 邀请下级
                _this.xia_children = e;
                _this.xia_show = !_this.xia_show;
            } else {
                // 邀请用户

                _this.user_children = e;

                _this.user_show = !_this.user_show;
            }
        },
        // 点击选择时间触发的方法
        timeChange(val) {
            if (val != null && val != '') {
                _this.search_data.create_time = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.create_time = '';
            }
        },

        searchDistributionPromoterLists() {
            _this.search_data.page = 1;
            _this.distributionPromoterLists();
        },

        distributionPromoterLists() {
            _this
                .$post('/distribution/distributionPromoterLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;

                    _this.val_port_array = _this.tableData[0].port.select_array;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.distributionPromoterLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
</style>